import { useHtmlStepperEditor } from './HtmlStepperEditorContext';
import { HtmlStepperEditorLogic } from './HtmlStepperEditorLogic';
import { HtmlStepperEditorModals } from './HtmlStepperEditorModals';
import { HtmlStepperEditorPreview } from './HtmlStepperEditorPreview';
import { HtmlStepperEditorResults } from './HtmlStepperEditorResults';
import { HtmlStepperEditorSidebar } from './HtmlStepperEditorSidebar';
import { HtmlStepperEditorStepsSidebar } from './HtmlStepperEditorStepsSidebar';
import { ThumbnailHarvesterProvider } from './ThumbnailHarvesterContext';

export const HtmlStepperEditorMainContent = () => {
  const { state } = useHtmlStepperEditor();
  const { editorMode } = state;

  return (
    <ThumbnailHarvesterProvider>
      <div className="relative flex h-full bg-white pt-12">
        {/* Sidebar - AI Chat */}
        <HtmlStepperEditorSidebar />

        <div className="relative flex flex-1">
          {/* Steps Sidebar - visible in editor mode only */}
          {(editorMode === 'editor' || editorMode === 'preview') && (
            <HtmlStepperEditorStepsSidebar />
          )}

          {/* Main content area */}
          <div className="relative flex-1">
            {/* Main content based on mode */}
            {editorMode === 'logic' && <HtmlStepperEditorLogic />}
            {editorMode === 'results' && <HtmlStepperEditorResults />}
            {/* Always render preview to keep iframe mounted */}
            <HtmlStepperEditorPreview />
          </div>

          {/* All Modals (Image, Action, Quiz Settings) */}
          <HtmlStepperEditorModals />
        </div>
      </div>
    </ThumbnailHarvesterProvider>
  );
};
